<template>
    <div>
        <h4>{{'List referrals'|translate}}</h4>

          <loading v-if="list_items == null" class="mt20" :text="'Please wait'|translate"></loading>

          <p
            class="mt20 alert alert-info"
            v-if="list_items && list_items.length == 0"
          >{{'There is no data'|translate}}</p>
          <table class="table mt10" v-if="list_items && list_items.length > 0">
            <thead>
              <tr>
                <th>{{'Phone'|translate}}</th>
                <th>{{'Ngày'|translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item) in list_items" :key="item.id">
               
                <td>{{ item.child_user.vn_phone }}</td>
                <td>{{ item.created_at| moment("from", "now") }}</td>
            
              </tr>
            </tbody>
          </table>
          <paginate
            v-if="total_page > 1"
            :page-count="total_page"
            :click-handler="clickPage"
            :prev-text="'Prev'|translate"
            :next-text="'Next'|translate"
            v-model="page"
            :container-class="'pagination'"
          ></paginate>
    </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
// import FormStore from '@/components/forms/FormStore'
import Paginate from "vuejs-paginate";
import Loading from "@/components/elements/Loading";
export default {
  name: "Home",
  components: {
    MyHeader,
    Paginate,
    Loading,
  },
  data() {
    return {
      show_form: false,
      pass_data: null,
      list_items: null,
      removing: false,
      page: 1,
      user: null,
      offset: 0,
      keyword: "",
      limit: Utils.getLimit(),
      total_page: 1
    };
  },
  methods: {
    modalData(data) {
      
      this.list();
    },
    showModal(data) {
      this.show_form = true;

      this.pass_data = data != null ? JSON.parse(JSON.stringify(data)) : data;

      setTimeout(() => {
        this.$refs.formstore.open();
      }, 100);
    },
    list() {
      let data = {
        page: this.page,
        limit: this.limit,
      };
      
      Utils.requestV2(this, true)
        .get(`/referrals/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          let data = response.data;
            
            let list = data.data;
            list = list.map(item => {
              let temp = new Date(item.created_at);
              item.created_at = this.$moment(temp);
              return item;
            });
            this.list_items = list;
           
            this.total_page = Utils.getTotalPages(response.data.total);
           
         
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },

    clickPage(pageNum) {
      console.log("pageNum", pageNum);
      this.page = pageNum;
      this.list();
    },
    search() {
      console.log("keyword", this.keyword);
      this.offset = 0;
      this.list();
    }
  },
  mounted() {
    this.list();

    this.user = Utils.getUser(this);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/ReferralList.vue